export default {
  'b2b-page': true,
  'canonical-urls': true,
  'cookie-banner': true,
  'course-rating-schema': false,
  'dato-route-updated-paths': true,
  'dynamic-thank-you': false,
  'hide-part-time-for-masters': true,
  'pdp-hero-form': false,
} satisfies Record<string, boolean>;
